import React from 'react';
import { Box, Menu, MenuItem } from '@mui/material';

interface MenuItemData {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  color?: string;
}

interface ActionMenuProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
  items: MenuItemData[];
}

export const ActionMenu: React.FC<ActionMenuProps> = ({
  anchorEl,
  open,
  onClose,
  items,
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          borderRadius: '8px',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
          mt: 0.5,
          minWidth: 150,
        },
      }}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            item.onClick();
            onClose();
          }}
          sx={{
            fontSize: item.color ? '12px' : '14px',
            py: 1.5,
            px: 2,
            color: item.color,
          }}
        >
          <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center' }}>
            {item.icon}
          </Box>
          {item.label}
        </MenuItem>
      ))}
    </Menu>
  );
};

